import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _excluded = ["children", "tableLayout"];

var _templateObject, _templateObject2, _templateObject3;

import React from 'react';
import styled from 'styled-components';
import chroma from 'chroma-js';
var TableCardWrapper = styled.table(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  border-collapse: separate;\n  border-spacing: 0;\n  width: 100%;\n  transition: all ease-in-out 0.1s;\n  table-layout: ", ";\n"])), function (props) {
  return props.tableLayout;
});

var TableCard = function TableCard(_ref) {
  var children = _ref.children,
      _ref$tableLayout = _ref.tableLayout,
      tableLayout = _ref$tableLayout === void 0 ? 'auto' : _ref$tableLayout,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(TableCardWrapper, _extends({
    tableLayout: tableLayout
  }, props), /*#__PURE__*/React.createElement("tbody", null, children));
};

TableCard.Row = styled.tr(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  td {\n    padding: 0.75rem;\n    border-top: solid ", " 1px;\n    border-bottom: ", ";\n    background-color: ", ";\n\n    &:first-child {\n      border-left: solid ", " 1px;\n    }\n    &:last-child {\n      border-right: solid ", " 1px;\n    }\n  }\n\n  &:first-child {\n    td {\n      &:first-child {\n        border-top-left-radius: 3px;\n      }\n      &:last-child {\n        border-top-right-radius: 3px;\n      }\n    }\n  }\n\n  &:last-child {\n    td {\n      border-bottom: solid ", " 1px;\n\n      &:first-child {\n        border-bottom-left-radius: 3px;\n      }\n      &:last-child {\n        border-bottom-right-radius: 3px;\n      }\n    }\n  }\n\n  & + tr {\n    td {\n      border-top: ", ";\n    }\n  }\n"])), function (props) {
  return props.active ? props.theme.colors.primary : props.theme.colors.grey;
}, function (props) {
  return props.active && "solid 1px ".concat(props.theme.colors.primary);
}, function (props) {
  return props.active && chroma(props.theme.colors.primary).alpha(0.05).hex();
}, function (props) {
  return props.active ? props.theme.colors.primary : props.theme.colors.grey;
}, function (props) {
  return props.active ? props.theme.colors.primary : props.theme.colors.grey;
}, function (props) {
  return props.active ? props.theme.colors.primary : props.theme.colors.grey;
}, function (props) {
  return props.active && 'none';
});
TableCard.Column = styled.td(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  vertical-align: ", ";\n  text-align: ", ";\n  min-width: ", ";\n  max-width: ", ";\n  width: ", ";\n"])), function (props) {
  return props.verticalAlign;
}, function (props) {
  return props.horizontalAlign;
}, function (props) {
  return props.minWidth;
}, function (props) {
  return props.maxWidth;
}, function (props) {
  return props.width;
});
export default TableCard;